module.exports = __webpack_public_path__ + "media/images/athletes/1403-76779f1c09300e3c4d160d81cff78f1c.png";